import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Lightbox } from "ngx-lightbox/lightbox.service";
import { c1, c3, c4, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Menu, MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-gen-menu-bg-image-component",
  templateUrl: "./gen-menu-bg-image-component.component.html",
  styleUrls: ["./gen-menu-bg-image-component.component.scss"],
})
export class GenMenuBgImageComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService,
    private lightbox: Lightbox
  ) {}

  @Input() menu_id: string;
  @Input() config: any;

  imageConfig: any = {};
  imageDarkConfig: any = {};
  bgimage: string = null;

  page: any;
  c4_value: string;
  c5_value: string;
  c3_value: string;
  offCanvasSubscription: any;
  albums = [];
  title: string;
  offcanvasColors = offcanvasColors;
  enableNav: boolean;
  singleTab: string = c3.SINGLE;
  mode: string;

  currentMenuSubscription: any;
  colorsComponentSubscription: any;
  menu: Menu;
  data: any;
  sync = true;
  isAndroid: boolean = false;
  toggleDarkImage = false;

  off_canvas_key: string = "gen";

  ngOnInit() {
    this.imageConfig = {
      id: this.menu_id,
      title: this.config && this.config.title ? this.config.title : "Image",
      max: this.config && this.config.max ? this.config.max : 1,
      aspectRatio:
        this.config && this.config.aspectRatio
          ? this.config.aspectRatio
          : "1x1",
      resizeToWidth:
        this.config && this.config.resizeToWidth
          ? this.config.resizeToWidth
          : 260,
      resizeToHeight:
        this.config && this.config.resizeToHeight
          ? this.config.resizeToHeight
          : 260,
      cropperView:
        this.config && this.config.cropperView
          ? this.config.cropperView
          : false,
      selectedImages: [],
      removeButton: true,
      imageType:
        this.config && this.config.imageType
          ? this.config.imageType
          : "image/png,",
      imageSet: false,
      keyword:
        this.config && this.config.keyword ? this.config.keyword : "Image",
      mode: ["upload", "gallery", "url"],
      params: "",
    };

    this.imageDarkConfig = {
      id: this.menu_id + "dark",
      title:
        this.config && this.config.title
          ? this.config.title + " Dark"
          : "Image",
      max: this.config && this.config.max ? this.config.max : 1,
      aspectRatio:
        this.config && this.config.aspectRatio
          ? this.config.aspectRatio
          : "1x1",
      resizeToWidth:
        this.config && this.config.resizeToWidth
          ? this.config.resizeToWidth
          : 260,
      resizeToHeight:
        this.config && this.config.resizeToHeight
          ? this.config.resizeToHeight
          : 260,
      cropperView:
        this.config && this.config.cropperView
          ? this.config.cropperView
          : false,
      selectedImages: [],
      removeButton: true,
      imageType:
        this.config && this.config.imageType
          ? this.config.imageType
          : "image/png,",
      imageSet: false,
      keyword:
        this.config && this.config.keyword ? this.config.keyword : "Image",
      mode: ["upload", "gallery", "url"],
      params: "",
    };

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "gen" &&
          data.menu_id == this.menu_id
        ) {
        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (data && data.menu && data.menu.menu_id == this.menu_id) {
          this.menu = data.menu;
          this.data = data;
          this.menuFunction();
        }
      }
    );

    this.colorsComponentSubscription =
      this.mdw.colorsComponentContainer$.subscribe((data) => {
        if (
          data &&
          data.color_schema &&
          data.color_schema_ios &&
          data.light != null
        ) {
        }
      });
  }

  menuFunction() {
    if (this.menu) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      if(this.isAndroid){
        if (this.menu.menu_bg && this.menu.menu_bg.image) {
          let media: any = {};
          media.permanentUrl = this.menu.menu_bg.image;
          this.imageConfig.selectedImages = [{ media: media }];
        }

        if (this.menu.menu_bg && this.menu.menu_bg.image_dark) {
          this.toggleDarkImage = true;
          let media: any = {};
          media.permanentUrl = this.menu.menu_bg.image_dark;
          this.imageDarkConfig.selectedImages = [{ media: media }];
        }
      }else{
        if (this.menu.menu_bg_ios && this.menu.menu_bg_ios.image) {
          let media: any = {};
          media.permanentUrl = this.menu.menu_bg_ios.image;
          this.imageConfig.selectedImages = [{ media: media }];
        }

        if (this.menu.menu_bg_ios && this.menu.menu_bg_ios.image_dark) {
          this.toggleDarkImage = true;
          let media: any = {};
          media.permanentUrl = this.menu.menu_bg_ios.image_dark;
          this.imageDarkConfig.selectedImages = [{ media: media }];
        }
      }

    }
  }

  buttonImage(value) {
    if (value && value.length > 0) {
      if (this.isAndroid || this.sync) {
        this.menu = {
          ...this.menu,
          menu_bg: {
            ...this.menu.menu_bg,
            image: value[0].media.permanentUrl,
          },
        };
      }
      if (!this.isAndroid || this.sync) {
        this.menu = {
          ...this.menu,
          menu_bg_ios: {
            ...this.menu.menu_bg_ios,
            image: value[0].media.permanentUrl,
          },
        };
      }
    } else {
      if (this.isAndroid || this.sync) {
        delete this.menu.menu_bg.image;
      }
      if (!this.isAndroid || this.sync) {
        delete this.menu.menu_bg_ios.image;
      }

        if (Object.keys(this.menu.menu_bg).length == 0) {
        delete this.menu.menu_bg;
      }

     if (Object.keys(this.menu.menu_bg_ios).length == 0) {
        delete this.menu.menu_bg_ios;
      }

    }

    this.updateMenuData();
  }

  buttonImageSet(value) {}

  enableDarkImageMode(e) {
    this.toggleDarkImage = e.target.checked;

    if (!this.toggleDarkImage) {
      delete this.menu.menu_bg.image_dark;
      delete this.menu.menu_bg_ios.image_dark;
      this.updateMenuData();
    }
  }

  buttonImageDark(value) {
    if (value && value.length > 0) {
      if (this.isAndroid || this.sync) {
        this.menu = {
          ...this.menu,
          menu_bg: {
            ...this.menu.menu_bg,
            image_dark: value[0].media.permanentUrl,
          },
        };
      }
      if (!this.isAndroid || this.sync) {
        this.menu = {
          ...this.menu,
          menu_bg_ios: {
            ...this.menu.menu_bg_ios,
            image_dark: value[0].media.permanentUrl,
          },
        };
      }



    } else {
      if (this.isAndroid || this.sync) {
        delete this.menu.menu_bg.image_dark;

      }
      if (!this.isAndroid || this.sync) {
        delete this.menu.menu_bg_ios.image_dark;
      }

      if (Object.keys(this.menu.menu_bg).length == 0) {
        delete this.menu.menu_bg;
      }

     if (Object.keys(this.menu.menu_bg_ios).length == 0) {
        delete this.menu.menu_bg_ios;
      }


    }
    this.updateMenuData();
  }

  updateMenuData() {
    //*must be there in all buttons
    // this.buttonList[this.button_id] = this.button;
    // let index = this.sortedButtonList[this.button.row_id].findIndex(
    //   (e) => e.button_id == this.button_id
    // );
    // this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    // this.data["sortedButtonList"] = this.sortedButtonList;
    // this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["menu"] = this.menu;
    let index = this.data['sortedMenuList'].findIndex((e) => e.menu_id == this.menu.menu_id);
    this.data['sortedMenuList'][index]=this.menu
    this.data['menuList'][this.menu.menu_id] = this.menu;
    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { menu: this.menu, tab: { module: "menu" } },
      this.mode,
      true
    );
  }
  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
  }
}
